export default {
    meta: {
    },
    scopes: null,
    rootUrl: '',
    modelsTimestamps:{},
    modelsFlagLoaded:{},
    modelsFetchHandler: {},
    selfUser: {},
    selfUserLoaded: false,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-api/state.js
// module id = null
// module chunks = 